module.exports = __webpack_public_path__ + "static/Majesti-LightItalic-8c542c11403b78be637edcad93bdbe80.otf";